<template>
    <transition name="fade" mode="out-in">
        <loader v-if="loading"></loader>
        <form v-else class="quotetool__step quotetool__step-confirmation">
            <section v-if="signingError == false" class="section--light-blue">
                <div class="container text-center">
                    <h2 class="quotetool__step-heading">
                        {{ labels.stepFiveTitle }}
                    </h2>
                    <div class="container--max-width-750">
                        <p>{{ labels.stepFiveSummary }}</p>                        
                    </div>
                    <a :href="documentUrl" target="_blank" type="button" class="btn btn--inline btn-download">{{ labels.stepFiveDownloadContactButton }}</a>
                </div>
            </section>
            <section v-if="signingError == false">
                <div class="container">
                    <div class="row">
                        <div class="col-xs-12 col-sm-6 text-center quotetool__step-confirmation-column">
                            <h2>{{ labels.stepFiveWhatsNextHeading }}</h2>

                            <p>{{ labels.stepFiveWhatsNextText }}</p>

                            <div v-html="labels.stepFiveWhatsNextList"></div>

                            <a class="btn btn--inline btn--chevron" :href="labels.stepFiveFAQButtonLink" >{{ labels.stepFiveFAQButton }}</a>
                        </div>
                        <div class="col-xs-12 col-sm-6 text-center quotetool__step-confirmation-column">
                            <h2>{{ labels.stepFiveAddServicesHeading }}</h2>
                            <!--stepFiveAddServicesText-->
                            <p>{{ labels.stepFiveAddServicesText }}</p>

                            <div v-html="labels.stepFiveAddServicesHeadingList"></div>
                           
                            <a class="btn btn--inline btn--chevron" :href="labels.stepFiveFindOutMoreButtonLink">{{ labels.stepFiveFindOutMoreButton }}</a>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-xs-12 text-center">
                            <p>{{ labels.stepFiveComplianceText }}</p>
                        </div>
                    </div>
                </div>
            </section>
            <section v-if="signingError">
                <div class="container">
                    <div class="row">
                        <div class="col-xs-12 text-center quotetool__step-confirmation-column">
                            <h2>{{ labels.stepFiveSigningErrorHeading }}</h2>
                            <p>{{ labels.stepFiveSigningErrorMessage }}</p>
                        </div>
                    </div>
                </div>
            </section>
        </form>
    </transition>
</template>

<script>
    import StepNavigation from '../StepNavigation.vue';
    import { createHelpers } from 'vuex-map-fields';

    import Loader from '../Loader.vue';

    import { mapActions, mapState } from 'vuex';

    const { mapFields } = createHelpers({
        getterType: 'completeStep/getField',
        mutationType: 'completeStep/updateField',
    });

    export default {
        components: {
            StepNavigation,
            Loader
        }, 

        mounted() {
            const urlParams = new URLSearchParams(window.location.search);
            const key = urlParams.get('key');

            if (key !== null) {
                this.confirmSigning(key).then(successfullySigned => {
  
                    if (successfullySigned) {
                        this.signingError = false;
                    } else {
                        this.signingError = true;
                    }
                    this.loading = false;
                }).catch(error => {
                    this.signingError = true;
                    this.loading = false;
                }) 
            }
        },

        computed: {
            ...mapFields([
                'documentUrl',
            ]),

            ...mapState('microcopy', [
                'labels',
            ])
        },

        data() {
            return {
                loading: true,
                signingError: null,
            }
        },

        methods: {
            ...mapActions('completeStep', [
                'confirmSigning',
            ])
        }
    }
</script>